module.exports = __webpack_public_path__ + "static/home_section_1_a-c7cd1bb1a5bd43de7dc69b444a722102.svg";